import _defineProperty from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { complex } from './index.mjs';
import { floatRegex } from '../utils.mjs';

/**
 * Properties that should default to 1 or 100%
 */
var maxDefaults = new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v) {
  var _v$slice$split = v.slice(0, -1).split("("),
    _v$slice$split2 = _slicedToArray(_v$slice$split, 2),
    name = _v$slice$split2[0],
    value = _v$slice$split2[1];
  if (name === "drop-shadow") return v;
  var _ref = value.match(floatRegex) || [],
    _ref2 = _slicedToArray(_ref, 1),
    number = _ref2[0];
  if (!number) return v;
  var unit = value.replace(number, "");
  var defaultValue = maxDefaults.has(name) ? 1 : 0;
  if (number !== value) defaultValue *= 100;
  return name + "(" + defaultValue + unit + ")";
}
var functionRegex = /([a-z-]*)\(.*?\)/g;
var filter = _objectSpread(_objectSpread({}, complex), {}, {
  getAnimatableNone: function getAnimatableNone(v) {
    var functions = v.match(functionRegex);
    return functions ? functions.map(applyDefaultFilter).join(" ") : v;
  }
});
export { filter };